/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2023
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/
import { defineMessages } from 'react-intl';

export const GenesysBotConnectorNew = defineMessages({
  titleOne: {
    id: 'GenesysBotConnector.GenesysBotConnectorNew.titleOne',
    defaultMessage: 'Your customers are on GenesysBotConnector'
  },
  subtitle: {
    id: 'GenesysBotConnector.GenesysBotConnectorNew.subtitle',
    defaultMessage:
      'Genesys BotConnector enables Architect to integrate messaging and conversation flows with your Watson Assistant chatbot, including quick replies and cards. <link>Learn more</link>'
  }
});

export const GenesysBotConnectorQuickSetup = defineMessages({
  title: {
    id: 'GenesysBotConnector.GenesysBotConnectorQuickSetup.title',
    defaultMessage: 'Set up GenesysBotConnector'
  },
  integrate: {
    id: 'GenesysBotConnector.GenesysBotConnectorQuickSetup.integrate',
    defaultMessage: 'Integrate with Assistant'
  },
  connectGenesysBotConnector: {
    id: 'GenesysBotConnector.GenesysBotConnectorQuickSetup.connectGenesysBotConnector',
    defaultMessage: 'Connect GenesysBotConnector'
  },
  configureGenesysBotConnector: {
    id: 'GenesysBotConnector.GenesysBotConnectorQuickSetup.configureGenesysBotConnector',
    defaultMessage: 'Configure GenesysBotConnector'
  },
  connectAssistant: {
    id: 'GenesysBotConnector.GenesysBotConnectorQuickSetup.connectAssistant',
    defaultMessage: 'Connect assistant'
  }
});

export const IntroStepMessages = defineMessages({
  instructions: {
    id: 'GenesysBotConnector.IntroStepMessages.instructions',
    defaultMessage: 'Steps to setting up Genesys bot connector'
  }
});

export const GenesysBotConnectorStepMessages = defineMessages({
  step1: {
    id: 'GenesysBotConnector.GenesysBotConnectorStepMessages.step1',
    defaultMessage: 'Set up Bot Connector in Genesys.'
  },
  step2: {
    id: 'GenesysBotConnector.GenesysBotConnectorStepMessages.step2',
    defaultMessage: 'Integrate with Assistant.'
  },
  step3: {
    id: 'GenesysBotConnector.GenesysBotConnectorStepMessages.step3',
    defaultMessage: 'Configure your Genesys BotConnector.'
  }
});
